import type { FC } from 'react';
import { memo, useEffect, useState } from 'react';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import type { PropsFromRedux } from './container';
import {
  PageContainer,
  SectionContent,
  SectionWrapper,
  StyledHeartIcon,
  ZipCodeDeliverableCheckWrapper,
} from './styles';
import { ZipCodeCheckFaq } from './ZipCodeCheckFaq';
import { ZipCodeDeliverableCheck } from './ZipCodeDeliverableCheck/container';

const ZipCodeCheckPage: FC<PropsFromRedux> = ({
  partnerContent,
  partner,
  dispatchSegmentTrack,
  isProvider,
  showHeartSVG,
  isAllina,
}) => {
  const [hasDispatchedViewEvent, setHasDispatchedViewEvent] = useState(false);

  useEffect(() => {
    if (!hasDispatchedViewEvent) {
      setHasDispatchedViewEvent(true);
      const promotionalValue = isProvider ? 'provider_zipcheck' : partner;
      dispatchSegmentTrack(UNIFIED.viewZipCheckerPage, { promotion_value: promotionalValue });
      dispatchSegmentTrack(UNIFIED.viewPromoLandingPage, { promotion_value: promotionalValue });
    }
  }, [hasDispatchedViewEvent]);

  return (
    <PageContainer>
      <SectionWrapper color="capsuleBlue50" isHero full>
        <SectionContent>
          <ZipCodeDeliverableCheckWrapper>
            <ZipCodeDeliverableCheck
              isProvider={isProvider}
              successBody={partnerContent?.successBody}
              successCTAText={partnerContent?.successCTAText}
              successCTAOnClick={partnerContent?.successCTAOnClick}
              CTATheme={isAllina ? 'capsuleGreen60' : undefined}
              showDeliverToWorkOption={partnerContent?.showDeliverToWorkOption}
            />
          </ZipCodeDeliverableCheckWrapper>
        </SectionContent>
        {showHeartSVG && <StyledHeartIcon iconString={CAPSULE_ICON_STRINGS.pill_heart_icon} raw />}
      </SectionWrapper>
      <ZipCodeCheckFaq promoValue={partner} />
    </PageContainer>
  );
};

export default memo(ZipCodeCheckPage);
